import { annualTop } from "@/mocks/ranking";

const chips = ["年度大盘点", "月度瓜榜", "反转之王", "深度补课", "素人爆冷"];

export default function Hero() {
  const preview = annualTop.slice(0, 5);

  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200">
      <div className="pointer-events-none absolute -right-24 -top-10 select-none font-serif text-[260px] font-black leading-none text-background-200/70 md:text-[380px]">
        TOP
      </div>

      <div className="relative mx-auto grid w-full max-w-7xl gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-8">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-bold tracking-widest text-primary-700">
            <i className="ri-fire-fill"></i>
            ANNUAL &amp; MONTHLY · 全网瓜料综合盘点
          </span>

          <h1 className="mt-6 font-serif text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            年度最劲爆
            <span className="text-primary-600">瓜榜大盘点</span>
            <br className="hidden sm:block" />
            一次把今年热点补齐
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            按<strong className="font-semibold text-foreground-900">热度</strong>、
            <strong className="font-semibold text-foreground-900">反转程度</strong>、
            <strong className="font-semibold text-foreground-900">影响范围</strong>三维综合排序，
            覆盖综艺、选秀、带货、商界、体育等圈层。想快速补课或者找下饭猛料，看这份瓜榜就够了。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#annual"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-base font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              查看 2026 年度 TOP10
              <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="#deep"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-background-100 px-7 py-3 text-base font-semibold text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-200"
            >
              从深度补课开始
            </a>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-foreground-500">热门话题：</span>
            {chips.map((c) => (
              <a
                key={c}
                href="#hot"
                className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                #{c}
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="font-serif text-lg font-bold text-foreground-950">
                <i className="ri-award-fill mr-1.5 text-accent-500"></i>
                年度瓜榜前五预览
              </h2>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
                火热连载中
              </span>
            </div>

            <ol className="mt-4 space-y-2.5">
              {preview.map((item) => (
                <li key={item.rank}>
                  <a
                    href="#annual"
                    className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 px-3 py-2.5 transition-colors hover:border-primary-200"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-serif text-base font-black ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="flex shrink-0 items-center gap-1 text-xs font-bold text-primary-600">
                      <i className="ri-fire-line"></i>
                      {item.heat}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
            <a
              href="#annual"
              className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              查看完整年度 TOP10
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}